
import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";

/**
 * 权益服务。
 * @class
 * @version 1.0.0
 */
export default class RightsService extends ServiceBase
{
    /*
     * 权益服务实例
     * @private
     * @return GaodeService
     */
    private static _instance: RightsService;

    /**
     * 权益服务实例
     * @static
     * @property
     * @returns RightsService
     */
    public static get instance(): RightsService
    {
        if(!this._instance)
        {
            this._instance = new RightsService();
        }
        
        return this._instance;
    }

    /**
     * 客户端获取订单列表数据
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async clientList(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.clientList({
            data: data
        });

        return response;
    }

    /**
     * 客户端获取订单详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getClient(id: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getClient({
            params:
            {
                id
            }
        });

        return response;
    }

    /**
     * 客户端取消订单
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async clientCancel(id: any): Promise<IHttpResponse>
    {
        let response = await this.apis.clientCancel({
            params:
            {
                id
            }
        });

        return response;
    }

    /**
     * 客户端激活订单
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async clientActive(id: any): Promise<IHttpResponse>
    {
        let response = await this.apis.clientActive({
            params:
            {
                id
            }
        });

        return response;
    }

    /**
     * 客户端获取卡片信息
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async clientGetCard(id: any): Promise<IHttpResponse>
    {
        let response = await this.apis.clientGetCard({
            params:
            {
                id
            }
        });

        return response;
    }

    /**
     * 通过人员权益id获取卡片信息
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async clientGetCardByMemberRightId(id: any): Promise<IHttpResponse>
    {
        let response = await this.apis.clientGetCardByMemberRightId({
            params:
            {
                id
            }
        });

        return response;
    }


    /**
     * 权益产品确认订单
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getRightsPreInfo(id: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getRightsPreInfo({
            params:
            {
                id
            }
        });

        return response;
    }

    /**
     * 权益产品继续支付
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async rightsProceedPay(id: string): Promise<IHttpResponse>
    {
        let response = await this.apis.rightsProceedPay({
            params:
            {
                id
            }
        });

        return response;
    }

    /**
     * 权益产品提交订单
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async createRightsOrder(data: any): Promise<IHttpResponse>
    {
        let response = await this.apis.createRightsOrder({data});
        return response;
    }


    /**
     * 客户端获取权益产品组详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getGroupProducts(orderId: any,groupId: any): Promise<IHttpResponse>
    {
        let response = await this.apis.getGroupProducts({params:{orderId,groupId}});
        return response;
    }

    /**
     * 获取权益体检套餐详情
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getByRights(data): Promise<IHttpResponse>
    {
        let response = await this.apis.getByRights({data:data});
        return response;
    }

    /**
     * 获取权益体检套餐机构排期
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getScheduleByRights(data): Promise<IHttpResponse>
    {
        let response = await this.apis.getScheduleByRights({data:data});
        return response;
    }

    /**
     * 获取权益体检套餐支持机构
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getSupportHospitalsByRights(data): Promise<IHttpResponse>
    {
        let response = await this.apis.getSupportHospitalsByRights({data:data});
        return response;
    }


    /**
     * 机构列表获取排期
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async supportHospitalSchedulesByRights(data): Promise<IHttpResponse>
    {
        let response = await this.apis.supportHospitalSchedulesByRights({data:data});
        return response;
    }

    /**
     * 客户端权益内体检订单预信息（权益内体检订单下单前的信息汇总）
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getPreOrderInfoByRights(data): Promise<IHttpResponse>
    {
        let response = await this.apis.getPreOrderInfoByRights({data:data});
        return response;
    }

    /**
     * 客户端权益内体检套餐下单
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async addByRights(data): Promise<IHttpResponse>
    {
        let response = await this.apis.addByRights({data:data});
        return response;
    }

    /**
     * 客户端权益卡兑换
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async rightsExchanged(data): Promise<IHttpResponse>
    {
        let response = await this.apis.rightsExchanged({data:data});
        return response;
    }

}
